import { useMemo } from 'preact/hooks'
import { checkConditions } from '@/components/helpers/metaobjects'
import { globalState } from '@/components/helpers/utils'
import { Criteria } from '@/components/helpers/metaobjects.types'

/**
 * Takes a criteria object to pass to checkConditions to validate what promo lines should display.
 */

export function usePromolines(criteria: Criteria) {
  return useMemo(() => {
    const data = globalState.metaobjects.promolines
    return data
      .filter((line) => checkConditions(line, criteria))
      .sort((a, b) => a.priority - b.priority)
  }, [])
}
